"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _default = {
  "tovo-san-giacomo": {
    "be678550": [{
      "hkey": "973ff7bd",
      "slug": "tovo-san-giacomo",
      "name": "Tovo San Giacomo",
      "primary": true,
      "skipSearch": false
    }],
    "borgate-boragni": [{
      "hkey": "973ff7bd",
      "slug": "tovo-san-giacomo",
      "name": "Tovo San Giacomo",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 9,
      "slugLevelParent": null
    }],
    "f39cb0b3": [{
      "hkey": "973ff7bd",
      "slug": "tovo-san-giacomo",
      "name": "Tovo San Giacomo",
      "primary": true,
      "skipSearch": false
    }],
    "bottasano": [{
      "hkey": "973ff7bd",
      "slug": "tovo-san-giacomo",
      "name": "Tovo San Giacomo",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 9,
      "slugLevelParent": null
    }],
    "82a34668": [{
      "hkey": "973ff7bd",
      "slug": "tovo-san-giacomo",
      "name": "Tovo San Giacomo",
      "primary": true,
      "skipSearch": false
    }],
    "bringhiera": [{
      "hkey": "973ff7bd",
      "slug": "tovo-san-giacomo",
      "name": "Tovo San Giacomo",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 9,
      "slugLevelParent": null
    }],
    "1a5cef07": [{
      "hkey": "973ff7bd",
      "slug": "tovo-san-giacomo",
      "name": "Tovo San Giacomo",
      "primary": true,
      "skipSearch": false
    }],
    "brunate": [{
      "hkey": "973ff7bd",
      "slug": "tovo-san-giacomo",
      "name": "Tovo San Giacomo",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 9,
      "slugLevelParent": null
    }],
    "3845a1ee": [{
      "hkey": "973ff7bd",
      "slug": "tovo-san-giacomo",
      "name": "Tovo San Giacomo",
      "primary": true,
      "skipSearch": false
    }],
    "case-grassi": [{
      "hkey": "973ff7bd",
      "slug": "tovo-san-giacomo",
      "name": "Tovo San Giacomo",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 9,
      "slugLevelParent": null
    }],
    "7ef67dbb": [{
      "hkey": "973ff7bd",
      "slug": "tovo-san-giacomo",
      "name": "Tovo San Giacomo",
      "primary": true,
      "skipSearch": false
    }],
    "ferro": [{
      "hkey": "973ff7bd",
      "slug": "tovo-san-giacomo",
      "name": "Tovo San Giacomo",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 9,
      "slugLevelParent": null
    }],
    "b428f885": [{
      "hkey": "973ff7bd",
      "slug": "tovo-san-giacomo",
      "name": "Tovo San Giacomo",
      "primary": true,
      "skipSearch": false
    }],
    "folchi": [{
      "hkey": "973ff7bd",
      "slug": "tovo-san-giacomo",
      "name": "Tovo San Giacomo",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 9,
      "slugLevelParent": null
    }],
    "6aa7cbec": [{
      "hkey": "6f49b4be",
      "slug": "centro",
      "name": "Centro",
      "primary": true,
      "skipSearch": false
    }],
    "giorni": [{
      "hkey": "6f49b4be",
      "slug": "centro",
      "name": "Centro",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 10,
      "slugLevelParent": "tovo-san-giacomo"
    }],
    "a508a1ab": [{
      "hkey": "6f49b4be",
      "slug": "centro",
      "name": "Centro",
      "primary": true,
      "skipSearch": false
    }],
    "morelli": [{
      "hkey": "6f49b4be",
      "slug": "centro",
      "name": "Centro",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 10,
      "slugLevelParent": "tovo-san-giacomo"
    }],
    "f50130da": [{
      "hkey": "973ff7bd",
      "slug": "tovo-san-giacomo",
      "name": "Tovo San Giacomo",
      "primary": true,
      "skipSearch": false
    }],
    "neuroni": [{
      "hkey": "973ff7bd",
      "slug": "tovo-san-giacomo",
      "name": "Tovo San Giacomo",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 9,
      "slugLevelParent": null
    }],
    "77776f74": [{
      "hkey": "973ff7bd",
      "slug": "tovo-san-giacomo",
      "name": "Tovo San Giacomo",
      "primary": true,
      "skipSearch": false
    }],
    "pelin": [{
      "hkey": "973ff7bd",
      "slug": "tovo-san-giacomo",
      "name": "Tovo San Giacomo",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 9,
      "slugLevelParent": null
    }],
    "510e17c1": [{
      "hkey": "6f49b4be",
      "slug": "centro",
      "name": "Centro",
      "primary": true,
      "skipSearch": false
    }],
    "poggio": [{
      "hkey": "6f49b4be",
      "slug": "centro",
      "name": "Centro",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 10,
      "slugLevelParent": "tovo-san-giacomo"
    }]
  }
};
exports["default"] = _default;